module.exports = __webpack_public_path__ + "static/media/order_type_insta.a31974b4.svg";